import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Layout from '../../components/Layout';

class _Layout extends Component {
  state = {}

  render() {
    const {children} = this.props;

    return (
      <Layout {...this.props} childrenContent={children}/>
    );
  }
}

_Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  roles: PropTypes.arrayOf(PropTypes.string),
  loadingFetchRoles: PropTypes.bool,
  fetchRoles: PropTypes.func.isRequired,
};

_Layout.defaultProps = {
  roles: null,
  loadingFetchRoles: false,
};

const mapStateToProps = (state) => ({
  roles: state.auth.roles,
  loadingFetchRoles: state.loading.effects.auth.fetchRoles,
});

const mapDispatchToProps = (dispatch) => ({
  fetchRoles: dispatch.auth.fetchRoles,
});

export default connect(mapStateToProps, mapDispatchToProps)(_Layout);
